
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _403Ts5OCAuyPVd4g2cNzgZjQNKVH69C9A7lRjzVFI_0x5sMeta } from "/var/www/mov-dev.m2lab.ru/pages/403.vue?macro=true";
import { default as index_jkGKcD1TthUdnMd0w3niMSNuwhPmr_45OC_GOnCVMmnEMeta } from "/var/www/mov-dev.m2lab.ru/pages/index.vue?macro=true";
import { default as logindGvrddiN04WFE_3mYGb_45FzWw2QjyBjXuKE5LQsZKWvsMeta } from "/var/www/mov-dev.m2lab.ru/pages/login.vue?macro=true";
import { default as usersrshF5FIel3An72CynjFkS5RI2zYqZlvfEQprhVPcMlkMeta } from "/var/www/mov-dev.m2lab.ru/pages/users.vue?macro=true";
import { default as kanban31v2mtsEfUZcXxeFPYMFUtAco9T8SvZv4EDwssAKycsMeta } from "/var/www/mov-dev.m2lab.ru/pages/kanban.vue?macro=true";
import { default as tabswyXfUpmsx5FmSvHGQEyFo4X0eGoMZKPbhPISn1G3iZcMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/tabs.vue?macro=true";
import { default as indexeF9TS3hLZLw5QDIfvRZHmLXLOT14plrTTMZoqpq2j2EMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/index.vue?macro=true";
import { default as phoneT4SLy1J_452Mfb4Q4AauUF4cOEQNCYrj1i2E92miWgqhkMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/phone.vue?macro=true";
import { default as _91_46_46_46slug_93vMbfeeVihg6lV95_458NM1fQAMY9EkKE3pCfXkUkCZkD0Meta } from "/var/www/mov-dev.m2lab.ru/pages/[...slug].vue?macro=true";
import { default as colors8AmrrFUH9fxHIIuXnF8089FIf56B0oJz8X21mwberwUMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/colors.vue?macro=true";
import { default as buttonsT4FsFa_MiosFcRnR0lKDoWMQyHFo8UwdqtMlCGJOjxAMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/buttons.vue?macro=true";
import { default as scannerSn_8hApzLwikmldYp_MQ7cAiNT2aYSM9B_45pbwYmEKr4Meta } from "/var/www/mov-dev.m2lab.ru/pages/ui/scanner.vue?macro=true";
import { default as _91page_93X1bKucV9tSIjilsTq6vnyRnbTgaAGsnA246f6f9VAM0Meta } from "/var/www/mov-dev.m2lab.ru/pages/lead/[page].vue?macro=true";
import { default as _91uuid_93StDKANJ1EbpMoj2Ah64Ljrc1IQAT0kzeK16l1I19dfgMeta } from "/var/www/mov-dev.m2lab.ru/pages/role/[uuid].vue?macro=true";
import { default as uploadervhbrVnUOT3eAtBx1Xi9e5zix7wVfqfA90JRPda6f9MsMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/uploader.vue?macro=true";
import { default as _91uuid_93o7ueDtW8uBwENFDeztCPwOIurhWJZEie0I1oQZ7vlg4Meta } from "/var/www/mov-dev.m2lab.ru/pages/batch/[uuid].vue?macro=true";
import { default as indexzzS1XDXl8m4vEOKrXOd6_eqvZCsPRSAkxqSB51Sv_45YEMeta } from "/var/www/mov-dev.m2lab.ru/pages/orders/index.vue?macro=true";
import { default as _91page_93dLTt0fCNP35H18sEmQ9w_Bwc8PfguoXXcwta1Nfylo8Meta } from "/var/www/mov-dev.m2lab.ru/pages/roles/[page].vue?macro=true";
import { default as selectboxDbAZijtPPCuAXc_DWlGopB5zLy7bMTnea8PDTZ4JjfAMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/selectbox.vue?macro=true";
import { default as _91page_932Mt4Ks_45FM0RJpRXVfMMZ6KG1QAyfJqnQWjKeR9UItfIMeta } from "/var/www/mov-dev.m2lab.ru/pages/orders/[page].vue?macro=true";
import { default as _91page_93KjujPMY2dZGiJIjhxZZlM9M9se9tjGAIi44sFHRGseIMeta } from "/var/www/mov-dev.m2lab.ru/pages/supply/[page].vue?macro=true";
import { default as datepickerOGPrKeqIKdjrHye8y7W3arOBIai2VrJnWQ_Nvbnh2GgMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/datepicker.vue?macro=true";
import { default as editortabs8_45_x2Ywz8aPse9bZINdnXXfUY9qGy_Ou_45T8om1yPmR8Meta } from "/var/www/mov-dev.m2lab.ru/pages/ui/editortabs.vue?macro=true";
import { default as _91page_93c1QIDO9Qcvpp2R5Pwz5pUCVPCt5Szz0w0U2JeYFhxgoMeta } from "/var/www/mov-dev.m2lab.ru/pages/barcode/[page].vue?macro=true";
import { default as _91page_93OoTO3DHBLiHtwbY6yhefesv2qESxr5xrqy8xGOq3MV8Meta } from "/var/www/mov-dev.m2lab.ru/pages/clients/[page].vue?macro=true";
import { default as index_d_45mGTlzoL_45CUQeE__5ngyeb9WJzg4JBTlMFRzRfPPQMeta } from "/var/www/mov-dev.m2lab.ru/pages/kiz/pool/index.vue?macro=true";
import { default as groupedK7VHLfl35APsIR0HtF7tD9ymVu1qdaiqmjsUlpt4G5IMeta } from "/var/www/mov-dev.m2lab.ru/pages/orders/grouped.vue?macro=true";
import { default as _91uuid_93PAInUYdlcJnYUbgF3fhFyZnKsP6N1RoTVU9b_45iEy2EUMeta } from "/var/www/mov-dev.m2lab.ru/pages/product/[uuid].vue?macro=true";
import { default as indexDCaW7Cds17wiaqzoIaJ8dpI_45dLIxl_Q1juRGkPU4mJEMeta } from "/var/www/mov-dev.m2lab.ru/pages/shipment/index.vue?macro=true";
import { default as forgot_45passwordCG4n_45GPc6_dD3NWmjQCcug9EMze9Bl_45PbhN21UOC7zIMeta } from "/var/www/mov-dev.m2lab.ru/pages/forgot-password.vue?macro=true";
import { default as _91page_93Jh5jvU30kwzSy6zHkL_45VQUa9O6EEvisJCxTxPEKdLGoMeta } from "/var/www/mov-dev.m2lab.ru/pages/products/[page].vue?macro=true";
import { default as indexkwXiDZ7Z5hq3n_A1iyIPqpdA60FGZx_45uHXhMxtv4FYcMeta } from "/var/www/mov-dev.m2lab.ru/pages/acceptance/index.vue?macro=true";
import { default as _91page_93Dp5O8PG9lktxs2mTqogJ5AtAR8b2p0idKfFWNVIsEfwMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse/[page].vue?macro=true";
import { default as _91page_93V9HgJ0o8VTPZ_45aI0TkZprJVs7vxrRwflke1TnwdsqRwMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouses/[page].vue?macro=true";
import { default as indexkxiSh0GQSsX165ZPqJR9FRZzT33VMzrgmX6vWj9T9uoMeta } from "/var/www/mov-dev.m2lab.ru/pages/returns/scan/index.vue?macro=true";
import { default as _91page_93o7LX2rQw0lj_COzqHMGbP_FmaekgooCN9X2Q8lfekVQMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/board/[page].vue?macro=true";
import { default as indexRsbDbBC3M47uAYdQhFMzvV44a022HNPpEIeWZF8IcN0Meta } from "/var/www/mov-dev.m2lab.ru/pages/notifications/index.vue?macro=true";
import { default as _91id_934RSjiQG3fJekSt6I3cVhHWEbhkpybb_457RHHr0HQYUCAMeta } from "/var/www/mov-dev.m2lab.ru/pages/supply/current/[id].vue?macro=true";
import { default as _91page_93xW65UK_tMK_45eY9iwd9rnDj52U8GcTbkb_bhyJ5UVTLgMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehousesman/[page].vue?macro=true";
import { default as _91id_93dPLL_NcQlt7fbu_45AoC2NCmTz_45CuBdVU_1Zol0m7xCbkMeta } from "/var/www/mov-dev.m2lab.ru/pages/shipment/current/[id].vue?macro=true";
import { default as addressSearchField_45Dfg8s9mav0iMJmMCImcKkow9HtOyb3xqHUEhHeGJSYMeta } from "/var/www/mov-dev.m2lab.ru/pages/ui/addressSearchField.vue?macro=true";
import { default as _91page_93tZubJ2MfXjIsw70a6njeZ_45ZZxsY_IY_45CEFGiqbzeiZUMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-cell/[page].vue?macro=true";
import { default as _91page_93mDWhImtuZNiu8RKAQzt_kHXQRiVtCk7PXmy4kvarGvkMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-task/[page].vue?macro=true";
import { default as _91token_937okqsz_45YhHokPDvd3ALLaaIkSZI7qdtbP6ByyutwIb4Meta } from "/var/www/mov-dev.m2lab.ru/pages/reset-password/[token].vue?macro=true";
import { default as _91page_93mANSSh_k3Dok8JbW9qb436TBOp1pn0G5AJ56DzYZG1UMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/cell-type/[page].vue?macro=true";
import { default as indextuK2SuX5l_jJ0JblKF5D_RFR7RiN7ILFm_5NFPCYMZkMeta } from "/var/www/mov-dev.m2lab.ru/pages/product-inventory/index.vue?macro=true";
import { default as _91page_93xn4FfkbmFg1f_45MFRcIyc1SwYKfuQB3o64zwTyv6ZKhIMeta } from "/var/www/mov-dev.m2lab.ru/pages/products-in-cell/[page].vue?macro=true";
import { default as indexXknF9zcE4PYTD0p6mEGlAnUyfir_mWlbNnOfG0BHJkMMeta } from "/var/www/mov-dev.m2lab.ru/pages/shipment/schedules/index.vue?macro=true";
import { default as _91page_93Qa5qyoWwjS2qEsWAkbNRxNAaI1_45b5jbaFZ9zE4HyAlYMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-service/[page].vue?macro=true";
import { default as _91page_93aSoSJikZHZi_twMoFQRpIyYqHVXHfzV_96q4y8OoFgsMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouseman-user/[page].vue?macro=true";
import { default as _91page_93LGLQ9gFk7VRxZklqn0v3O_39m9IoDD_45wAPYUj0KQ0_45gMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/region-type/[page].vue?macro=true";
import { default as _91uuid_937ozIpZK5jUZXHLrtx5L_45vPPCRofkzEUDntKMhYrgyIsMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/board-status/[uuid].vue?macro=true";
import { default as _91page_93KRxJHa_450svtcq_uUnAIufoRG42s1i_norUNEWhQeEscMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/product-type/[page].vue?macro=true";
import { default as _91uuid_93on2FXyWaXjuFhNBbknRRAsA_IOxHP7c6PdOfr4Hu98sMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-task/view/[uuid].vue?macro=true";
import { default as _91page_938sZ_45_45IVvaSZZmgS7_LNkAKDj3mMp7csR5BkLhEyvI4AMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/client-service/[page].vue?macro=true";
import { default as _91page_93PQlREpTQvKi5sgfUhQsCFfFFT7jz5LP5ObnMWGL3VXwMeta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/lead-task-type/[page].vue?macro=true";
import { default as _91page_93r3uAmZkOBi6_wMtUT7it50qisTApixZaZ7JSimmQ_45k4Meta } from "/var/www/mov-dev.m2lab.ru/pages/lookup/product-category/[page].vue?macro=true";
import { default as _91page_93QfjN8a5zBqyNb46FAndUIT5FXBLcYA9YzffzUOiLBRgMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-task/selection/[page].vue?macro=true";
import { default as indexEtDZG09OUovjZqVme_45vxHChHqzGqbz_OsIE9PedCAJoMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehousesman/editor-user/index.vue?macro=true";
import { default as _91page_93viVwGvyhscMSAt0pWtZ7AOtm_45bYyGTeeYlusNC0idyoMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-task/acceptance/[page].vue?macro=true";
import { default as _91_46_46_46uuid_93Ae_hdyHdzHamb_tZYY6C3Suo6_45asDVm4bAIqBO1Ik5wMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-task/current/[...uuid].vue?macro=true";
import { default as _91page_93Y0Mon4MHxooU7q7j6PEFvHg7xwLUXIYileGrTRHhw9IMeta } from "/var/www/mov-dev.m2lab.ru/pages/warehouse-task/moving-acceptance/[page].vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/403.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logindGvrddiN04WFE_3mYGb_45FzWw2QjyBjXuKE5LQsZKWvsMeta || {},
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/login.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/users.vue")
  },
  {
    name: "kanban",
    path: "/kanban",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/kanban.vue")
  },
  {
    name: "ui-tabs",
    path: "/ui/tabs",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/tabs.vue")
  },
  {
    name: "ui",
    path: "/ui",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/index.vue")
  },
  {
    name: "ui-phone",
    path: "/ui/phone",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/phone.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/[...slug].vue")
  },
  {
    name: "ui-colors",
    path: "/ui/colors",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/colors.vue")
  },
  {
    name: "ui-buttons",
    path: "/ui/buttons",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/buttons.vue")
  },
  {
    name: "ui-scanner",
    path: "/ui/scanner",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/scanner.vue")
  },
  {
    name: "lead-page",
    path: "/lead/:page()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lead/[page].vue")
  },
  {
    name: "role-uuid",
    path: "/role/:uuid()",
    meta: { ...(_91uuid_93StDKANJ1EbpMoj2Ah64Ljrc1IQAT0kzeK16l1I19dfgMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/role/[uuid].vue")
  },
  {
    name: "ui-uploader",
    path: "/ui/uploader",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/uploader.vue")
  },
  {
    name: "batch-uuid",
    path: "/batch/:uuid()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/batch/[uuid].vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexzzS1XDXl8m4vEOKrXOd6_eqvZCsPRSAkxqSB51Sv_45YEMeta || {},
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/orders/index.vue")
  },
  {
    name: "roles-page",
    path: "/roles/:page()",
    meta: { ...(_91page_93dLTt0fCNP35H18sEmQ9w_Bwc8PfguoXXcwta1Nfylo8Meta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/roles/[page].vue")
  },
  {
    name: "ui-selectbox",
    path: "/ui/selectbox",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/selectbox.vue")
  },
  {
    name: "orders-page",
    path: "/orders/:page()",
    meta: { ...(_91page_932Mt4Ks_45FM0RJpRXVfMMZ6KG1QAyfJqnQWjKeR9UItfIMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/orders/[page].vue")
  },
  {
    name: "supply-page",
    path: "/supply/:page()",
    meta: { ...(_91page_93KjujPMY2dZGiJIjhxZZlM9M9se9tjGAIi44sFHRGseIMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/supply/[page].vue")
  },
  {
    name: "ui-datepicker",
    path: "/ui/datepicker",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/datepicker.vue")
  },
  {
    name: "ui-editortabs",
    path: "/ui/editortabs",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/editortabs.vue")
  },
  {
    name: "barcode-page",
    path: "/barcode/:page()",
    meta: { ...(_91page_93c1QIDO9Qcvpp2R5Pwz5pUCVPCt5Szz0w0U2JeYFhxgoMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/barcode/[page].vue")
  },
  {
    name: "clients-page",
    path: "/clients/:page()",
    meta: { ...(_91page_93OoTO3DHBLiHtwbY6yhefesv2qESxr5xrqy8xGOq3MV8Meta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/clients/[page].vue")
  },
  {
    name: "kiz-pool",
    path: "/kiz/pool",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/kiz/pool/index.vue")
  },
  {
    name: "orders-grouped",
    path: "/orders/grouped",
    meta: { ...(groupedK7VHLfl35APsIR0HtF7tD9ymVu1qdaiqmjsUlpt4G5IMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/orders/grouped.vue")
  },
  {
    name: "product-uuid",
    path: "/product/:uuid()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/product/[uuid].vue")
  },
  {
    name: "shipment",
    path: "/shipment",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/shipment/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordCG4n_45GPc6_dD3NWmjQCcug9EMze9Bl_45PbhN21UOC7zIMeta || {},
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/forgot-password.vue")
  },
  {
    name: "products-page",
    path: "/products/:page()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/products/[page].vue")
  },
  {
    name: "acceptance",
    path: "/acceptance",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/acceptance/index.vue")
  },
  {
    name: "warehouse-page",
    path: "/warehouse/:page()",
    meta: { ...(_91page_93Dp5O8PG9lktxs2mTqogJ5AtAR8b2p0idKfFWNVIsEfwMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse/[page].vue")
  },
  {
    name: "warehouses-page",
    path: "/warehouses/:page()",
    meta: { ...(_91page_93V9HgJ0o8VTPZ_45aI0TkZprJVs7vxrRwflke1TnwdsqRwMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouses/[page].vue")
  },
  {
    name: "returns-scan",
    path: "/returns/scan",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/returns/scan/index.vue")
  },
  {
    name: "lookup-board-page",
    path: "/lookup/board/:page()",
    meta: { ...(_91page_93o7LX2rQw0lj_COzqHMGbP_FmaekgooCN9X2Q8lfekVQMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/board/[page].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/notifications/index.vue")
  },
  {
    name: "supply-current-id",
    path: "/supply/current/:id()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/supply/current/[id].vue")
  },
  {
    name: "warehousesman-page",
    path: "/warehousesman/:page()",
    meta: { ...(_91page_93xW65UK_tMK_45eY9iwd9rnDj52U8GcTbkb_bhyJ5UVTLgMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehousesman/[page].vue")
  },
  {
    name: "shipment-current-id",
    path: "/shipment/current/:id()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/shipment/current/[id].vue")
  },
  {
    name: "ui-addressSearchField",
    path: "/ui/addressSearchField",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/ui/addressSearchField.vue")
  },
  {
    name: "warehouse-cell-page",
    path: "/warehouse-cell/:page()",
    meta: { ...(_91page_93tZubJ2MfXjIsw70a6njeZ_45ZZxsY_IY_45CEFGiqbzeiZUMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-cell/[page].vue")
  },
  {
    name: "warehouse-task-page",
    path: "/warehouse-task/:page()",
    meta: { ...(_91page_93mDWhImtuZNiu8RKAQzt_kHXQRiVtCk7PXmy4kvarGvkMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-task/[page].vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    meta: _91token_937okqsz_45YhHokPDvd3ALLaaIkSZI7qdtbP6ByyutwIb4Meta || {},
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/reset-password/[token].vue")
  },
  {
    name: "lookup-cell-type-page",
    path: "/lookup/cell-type/:page()",
    meta: { ...(_91page_93mANSSh_k3Dok8JbW9qb436TBOp1pn0G5AJ56DzYZG1UMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/cell-type/[page].vue")
  },
  {
    name: "product-inventory",
    path: "/product-inventory",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/product-inventory/index.vue")
  },
  {
    name: "products-in-cell-page",
    path: "/products-in-cell/:page()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/products-in-cell/[page].vue")
  },
  {
    name: "shipment-schedules",
    path: "/shipment/schedules",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/shipment/schedules/index.vue")
  },
  {
    name: "warehouse-service-page",
    path: "/warehouse-service/:page()",
    meta: { ...(_91page_93Qa5qyoWwjS2qEsWAkbNRxNAaI1_45b5jbaFZ9zE4HyAlYMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-service/[page].vue")
  },
  {
    name: "warehouseman-user-page",
    path: "/warehouseman-user/:page()",
    meta: { ...(_91page_93aSoSJikZHZi_twMoFQRpIyYqHVXHfzV_96q4y8OoFgsMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouseman-user/[page].vue")
  },
  {
    name: "lookup-region-type-page",
    path: "/lookup/region-type/:page()",
    meta: { ...(_91page_93LGLQ9gFk7VRxZklqn0v3O_39m9IoDD_45wAPYUj0KQ0_45gMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/region-type/[page].vue")
  },
  {
    name: "lookup-board-status-uuid",
    path: "/lookup/board-status/:uuid()",
    meta: { ...(_91uuid_937ozIpZK5jUZXHLrtx5L_45vPPCRofkzEUDntKMhYrgyIsMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/board-status/[uuid].vue")
  },
  {
    name: "lookup-product-type-page",
    path: "/lookup/product-type/:page()",
    meta: { ...(_91page_93KRxJHa_450svtcq_uUnAIufoRG42s1i_norUNEWhQeEscMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/product-type/[page].vue")
  },
  {
    name: "warehouse-task-view-uuid",
    path: "/warehouse-task/view/:uuid()",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-task/view/[uuid].vue")
  },
  {
    name: "lookup-client-service-page",
    path: "/lookup/client-service/:page()",
    meta: { ...(_91page_938sZ_45_45IVvaSZZmgS7_LNkAKDj3mMp7csR5BkLhEyvI4AMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/client-service/[page].vue")
  },
  {
    name: "lookup-lead-task-type-page",
    path: "/lookup/lead-task-type/:page()",
    meta: { ...(_91page_93PQlREpTQvKi5sgfUhQsCFfFFT7jz5LP5ObnMWGL3VXwMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/lead-task-type/[page].vue")
  },
  {
    name: "lookup-product-category-page",
    path: "/lookup/product-category/:page()",
    meta: { ...(_91page_93r3uAmZkOBi6_wMtUT7it50qisTApixZaZ7JSimmQ_45k4Meta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/lookup/product-category/[page].vue")
  },
  {
    name: "warehouse-task-selection-page",
    path: "/warehouse-task/selection/:page()",
    meta: { ...(_91page_93QfjN8a5zBqyNb46FAndUIT5FXBLcYA9YzffzUOiLBRgMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-task/selection/[page].vue")
  },
  {
    name: "warehousesman-editor-user",
    path: "/warehousesman/editor-user",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehousesman/editor-user/index.vue")
  },
  {
    name: "warehouse-task-acceptance-page",
    path: "/warehouse-task/acceptance/:page()",
    meta: { ...(_91page_93viVwGvyhscMSAt0pWtZ7AOtm_45bYyGTeeYlusNC0idyoMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-task/acceptance/[page].vue")
  },
  {
    name: "warehouse-task-current-uuid",
    path: "/warehouse-task/current/:uuid(.*)*",
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-task/current/[...uuid].vue")
  },
  {
    name: "warehouse-task-moving-acceptance-page",
    path: "/warehouse-task/moving-acceptance/:page()",
    meta: { ...(_91page_93Y0Mon4MHxooU7q7j6PEFvHg7xwLUXIYileGrTRHhw9IMeta || {}), ...{"middleware":"can-view"} },
    component: () => import("/var/www/mov-dev.m2lab.ru/pages/warehouse-task/moving-acceptance/[page].vue")
  }
]